export enum ValueReferenceTypeEnum {
  FRACTION_1_10 = '1/10',
  FRACTION_1_9 = '1/9',
  FRACTION_1_8 = '1/8',
  FRACTION_1_7 = '1/7',
  FRACTION_1_6 = '1/6',
  FRACTION_1_5 = '1/5',
  FRACTION_1_4 = '1/4',
  FRACTION_1_3 = '1/3',
  FRACTION_1_2 = '1/2',
  FRACTION_1_1 = '1/1',
}

export enum ValueReferenceTypeIdEnum {
  'SISTEMA' = 1,
  'APLICAÇÃO' = 2,
  SYSTEM,
  APPLICATION
}

export function getValueReferenceTypeDescriptionByValue(value: number) {
  const indexOfS = Object.values(ValueReferenceTypeIdEnum).indexOf(
    value as unknown as ValueReferenceTypeIdEnum
  );

  const key = Object.keys(ValueReferenceTypeIdEnum)[indexOfS];

  return key;
}


